import { render, staticRenderFns } from "./AutomationSidebar.vue?vue&type=template&id=838e635c&scoped=true&"
import script from "./AutomationSidebar.vue?vue&type=script&lang=js&"
export * from "./AutomationSidebar.vue?vue&type=script&lang=js&"
import style0 from "./AutomationSidebar.vue?vue&type=style&index=0&id=838e635c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "838e635c",
  null
  
)

export default component.exports